module.exports = __webpack_public_path__ + "img/ic-list.52965c89.svg";